import { useContext } from "react";
import { useGetLinkEntitiesRequest } from "src/services/link/queries/entities";

import Context from "../context";

export const useGetLinkEntities = () => {
	const { state } = useContext(Context);
	const { isError, isLoading } = useGetLinkEntitiesRequest(state.authToken);

	return { isError, isLoading };
};
